module.exports = __webpack_public_path__ + "img/eid-al-fitr.832fb956.png";